import { Component } from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { setHeaderTitle } from '../../store/layout/actionCreator'

export class HeaderTitle extends Component {
  static propTypes = {
    setHeaderTitle: func,
    title: string,
  }

  UNSAFE_componentWillMount() {
    this.props.setHeaderTitle(this.props.title)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.title && this.props.title !== nextProps.title) {
      this.props.setHeaderTitle(nextProps.title)
    }
  }

  render() {
    return null
  }
}

const mapDispatchToProps = { setHeaderTitle }

export default connect(null, mapDispatchToProps)(HeaderTitle)
